export const AUTH_ERROR = {
  USER_NOT_FOUND: 'auth/user-not-found',
  INCORRECT_PASSWORD: 'auth/wrong-password',
  SIGN_IN_DIFFERENTLY: 'auth/account-exists-with-different-credential',
  NOT_ALLOW_ON_WEB: 'tcasterweb/authen-not-allow-first-time',
  NETWORK_FAIL: 'auth/network-request-failed',
  POPUP_CLOSE_PREMATURE: 'auth/popup-closed-by-user',
  EMAIL_IS_ALREADY_IN_USE: 'auth/email-already-in-use',
};

export function resolveErrorCode(errorCode) {
  switch (errorCode) {
    case AUTH_ERROR.USER_NOT_FOUND:
    case AUTH_ERROR.INCORRECT_PASSWORD:
      return 'กรุณาตรวจสอบ อีเมล หรือ รหัสผ่าน ของคุณว่าถูกต้องหรือไม่';

    case AUTH_ERROR.SIGN_IN_DIFFERENTLY:
      return 'คุณเคยใช้อีเมลนี้ในการสมัครอีกช่องทาง กรุณาตรวจสอบว่าคุณเคยสมัครผ่านเฟซบุคหรืออีเมล';
    case AUTH_ERROR.NOT_ALLOW_ON_WEB:
      return 'กรุณาโหลดแอปเพื่อลงทะเบียนก่อน';
    case AUTH_ERROR.POPUP_CLOSE_PREMATURE:
      return 'กรุณาเปิดให้ใช้ Cookies ในบราวเซอร์ของคุณ';
    case AUTH_ERROR.NETWORK_FAIL:
      return 'มีปัญหาในการเชื่อมต่ออินเตอร์เน็ต';
    // case USER_NOT_FOUND:
    //   return 'ไม่มีอีเมลนี้อยู่ในระบบ';
    case AUTH_ERROR.EMAIL_IS_ALREADY_IN_USE:
      return 'อีเมลนี้ไม่สามารถใช้งานได้ เนื่องจากมีอยู่ในระบบแล้ว';
    default:
      return 'มีปัญหาในการล็อกอิน';
  }
}

const codes = [
  'auth/user-not-found',
  'auth/wrong-password',
  'auth/account-exists-with-different-credential',
  'tcasterweb/authen-not-allow-first-time',
];
